import React, { Component } from "react";
import { bool, node, string, arrayOf, oneOfType } from "prop-types";
import { isIOS } from "react-device-detect";

import PageLoading from "pages/_components/PageLoading";

export const MainContainerContext = React.createContext();

class MainContainer extends Component {
    static propTypes = {
        children: oneOfType([arrayOf(node), node]),
        className: string,
        showLoader: bool,
        showChildrenWithLoader: bool,
        ref: string,
    };

    static defaultProps = {
        children: null,
        className: "",
        showLoader: false,
        showChildrenWithLoader: false,
        ref: "",
    };

    render() {
        const { ref, className, showLoader, showChildrenWithLoader, children } = this.props;

        return (
            <PageLoading loading={showLoader}>
                <section className={isIOS ? "main-wrapper main-wrapper-ios" : "main-wrapper"}>
                    <div id="mainContainer" className={`main-container ${className}`} ref={ref}>
                        {showChildrenWithLoader ? children : !showLoader && children}
                    </div>
                </section>
            </PageLoading>
        );
    }
}

export default MainContainer;
